import { getDataCookie } from 'common';
import constant from 'constant';
import moment from 'moment';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import SockJS from 'sockjs-client';
import { over } from 'stompjs';
import aptActions from 'store/appt/actions';
import { useAppDispatch } from 'store/hooks';
export const SocketTopic = {
  STAFF_INCOME: '/topic/staff/income',
  STAFF_APPOINTMENT: '/topic/appointment-staff',
}
export const SocketRef = React.createRef();
const SocketContext = forwardRef((_, ref) => {
  const dispatch = useAppDispatch();
  const [, setStompClient] = useState(null);
  const listeners = useRef({
    [SocketTopic.STAFF_APPOINTMENT]: () => undefined,
    [SocketTopic.STAFF_INCOME]: () => undefined,
  });

  const subscribe = (topic, listener) => {
    listeners.current[topic] = listener;
  };


  const onRefreshApt = () => {
    const dateMoment = moment().format('YYYY-MM-DD');
    const range_param = `start_time=${dateMoment}&end_time=${dateMoment}`;
    let query = range_param;
    const staffId = getDataCookie(process.env.REACT_APP_COOKIE_KEY);
    if (staffId) {
      query += '&staffId=' + staffId;
    }
    dispatch(aptActions.getAptData.fetch(query));
  }

  const connectStaffSocket = (staffId) => {
    var socket = new SockJS(constant.SOCKET_URL);
    var _stompClient = null;
    _stompClient = over(socket);
    setStompClient(_stompClient);
    _stompClient.connect({}, () => {
      _stompClient.subscribe(`${SocketTopic.STAFF_INCOME}/${staffId}`, (res) => {
        listeners.current?.[SocketTopic.STAFF_INCOME]?.(res);
      });
      _stompClient.subscribe(`${SocketTopic.STAFF_APPOINTMENT}/${staffId}`, (res) => {
        onRefreshApt();
        listeners.current?.[SocketTopic.STAFF_APPOINTMENT]?.(res);
      });
    });
  };

  useImperativeHandle(ref, () => ({
    subscribe,
    connectStaffSocket,
  }));

  return <></>;
});

SocketContext.displayName = 'SocketContext';

export default SocketContext;
